import React from 'react';
import { hot } from 'react-hot-loader';
import Link from 'redux-first-router-link';
import LazyImage from '../../../hocs/Lazy/LazyImage';
import { purifier } from '../../../utils/dom';
import { imageSizeTranslation } from '../../../utils/image';
import { prefix } from '../../../utils/locale';
import { cleanInternalLinks } from '../../../utils/string';
import s from './Image.scss';

const Image = ({ content, attrs, setup, column = 'full', first = false, extraProps = null, imageWidth = false, lazyLoad, isSizeGuide = false, gender = false }) => {
	let Wrapper = ({ children }) => children;

	const imageGender = (content?.caption?.rawText || '').toLowerCase().match(/%((wo)?men)%/)?.[1];
	if (gender && imageGender !== gender) return null;

	if (attrs?.href) {
		const link = cleanInternalLinks(attrs.href);
		const externalLink = /^(https?|mailto|tel)/.test(link);
		const anchorLink = /^#/.test(link);

		if (attrs.target || externalLink || anchorLink) {
			Wrapper = ({ children }) => (
				<a href={link} target="_blank" rel="noopener noreferrer">
					{ children }
				</a>
			);
		} else {
			Wrapper = ({ children }) => (
				<Link to={prefix(setup, link)}>
					{ children }
				</Link>
			);
		}
	}

	if (first && !lazyLoad) lazyLoad = 'eager';

	return (
		<Wrapper>
			<figure className={[s.image, (isSizeGuide ? s.image__sizeGuide : null)].join(' ')}>
				{ content.image.url && <LazyImage className={s.image_image} {...imageSizeTranslation(column, content.image, '-', lazyLoad, false, imageWidth)} {...extraProps} /> }
				{ content.caption && <figcaption className={s.image_caption} dangerouslySetInnerHTML={{ __html: purifier(content.caption.rawText) }} /> }
			</figure>
		</Wrapper>
	);
};

export default hot(module)(Image);
